import { ArrayResource } from 'RtUi/utils/http/resources/ArrayResource';
import { IMetricsCountsIndex } from 'RtUi/app/rtDid/Dashboard/lib/http/DidMetricHttp';

export class DidMetricCountResource extends ArrayResource<IMetricsCountsIndex> {
	constructor(records?: IMetricsCountsIndex[]) {
		super('value', records);
	}
}
